import _ from 'lodash';
import { baseUnit } from './baseUnit';
import { kgToSellingUnitQuantity } from './kgToSellingUnitQuantity';
import { productAlias } from './productAlias';
import { numFormat, unitPriceFormat } from './numFormat';
import { productInvoiceName } from './productInvoiceName';

export function formatOrderForInvoice(invoiceDetails: any, vatPercent: number): any[] {
  const returnedOrders: any[] = [];
  _.forEach(invoiceDetails.orders, (order: any, index: number) => {
    const description = productInvoiceName(productAlias(_.get(order, 'id.product')), order.lineNumber, order.itemNumber);
    let orderFg = invoiceDetails.allFG.find((fg: any) => fg._id == order.fg);
    if(!orderFg) orderFg = invoiceDetails.allFG[index];
    if(order.quantity > 0) {
      const unitPrice = _.get(order, 'id.unitPrice', '');
      let quantity: string | number = kgToSellingUnitQuantity(_.get(order, 'id'), orderFg, order.quantity);
      if((order.value/unitPrice) != Number(quantity)) {
        quantity = numFormat(order.value/unitPrice);
      }
      const obj = {
        slNo: `${index + 1}/${invoiceDetails.orders.length}`,
        cadisItemCode: _.get(order, 'id.product._id', ''),
        order: _.get(order, 'id._id', ''),
        description,
        unit: baseUnit(_.get(order, 'id.product', '')),
        quantity: `${quantity}`,
        currency: 'SAR',
        unitPrice: `${unitPriceFormat(unitPrice, true)}`,
        subTotal: `${numFormat(order.value)}`,
        vatRate: `${vatPercent} %`,
        vatValue: `${numFormat(((order.value*vatPercent)/100))}`,
        total: `${numFormat(((order.value*(100+vatPercent))/100))}`
      }
      returnedOrders.push(obj);
    }
    if(order.FOC) {
      const obj = {
        cadisItemCode: _.get(order, 'id.product._id', ''),
        order: _.get(order, 'id._id', ''),
        description,
        unit: baseUnit(_.get(order, 'id.product', '')),
        quantity: `${kgToSellingUnitQuantity(_.get(order, 'id'), orderFg, order.FOC)}`,
        currency: 'SAR',
        unitPrice: 'FOC',
        subTotal: `${numFormat(0)}`,
        vatRate: `${vatPercent} %`,
        vatValue: `${numFormat(0)}`,
        total: `${numFormat(0)}`,
      }
      returnedOrders.push(obj);
    }
    if(order.additionalCharges > 0) {
      const obj = {
        description: order.additionalChargesType,
        currency: 'SAR',
        subTotal: `${numFormat(order.additionalCharges)}`,
        vatRate: `${vatPercent} %`,
        vatValue: `${numFormat(((order.additionalCharges*vatPercent)/100))}`,
        total: `${numFormat(((order.additionalCharges*(100+vatPercent))/100))}`
      }
      returnedOrders.push(obj);
    }
  })
  _.forEach(invoiceDetails.callOffs, (callOffItem: any, index: number) => {
    const description = productInvoiceName(productAlias(_.get(callOffItem, 'callOff.product')), callOffItem.lineNumber, callOffItem.itemNumber);
    const orderNo = _.last(_.sortBy(_.map(callOffItem.orders, 'order')));
    if(callOffItem.quantity > 0) {
      const unitPrice = _.get(callOffItem, 'callOff.unitPrice', '');
      let quantity: string | number = callOffItem.quantity;
      if((callOffItem.value/unitPrice) != Number(quantity)) {
        quantity = numFormat(callOffItem.value/unitPrice);
      }
      const obj = {
        slNo: `${index + 1}/${invoiceDetails.callOffs.length}`,
        cadisItemCode: _.get(callOffItem, 'callOff.product._id', ''),
        callOff: _.get(callOffItem, 'callOff._id', ''),
        order: orderNo,
        description,
        unit: baseUnit(_.get(callOffItem, 'callOff.product', '')),
        quantity: `${quantity}`,
        currency: 'SAR',
        unitPrice: `${unitPriceFormat(unitPrice, true)}`,
        subTotal: `${numFormat(callOffItem.value)}`,
        vatRate: `${vatPercent} %`,
        vatValue: `${numFormat(((callOffItem.value*vatPercent)/100))}`,
        total: `${numFormat(((callOffItem.value*(100+vatPercent))/100))}`
      }
      returnedOrders.push(obj);
    }
    if(callOffItem.FOC) {
      const obj = {
        cadisItemCode: _.get(callOffItem, 'callOff.product._id', ''),
        order: orderNo,
        description,
        unit: baseUnit(_.get(callOffItem, 'callOff.product', '')),
        quantity: `${callOffItem.FOC}`,
        currency: 'SAR',
        unitPrice: 'FOC',
        subTotal: `${numFormat(0)}`,
        vatRate: `${vatPercent} %`,
        vatValue: `${numFormat(0)}`,
        total: `${numFormat(0)}`,
      }
      returnedOrders.push(obj);
    }
    if(callOffItem.additionalCharges > 0) {
      const obj = {
        description: callOffItem.callOff.additionalChargesType,
        currency: 'SAR',
        subTotal: `${numFormat(callOffItem.additionalCharges)}`,
        vatRate: `${vatPercent} %`,
        vatValue: `${numFormat(((callOffItem.additionalCharges*vatPercent)/100))}`,
        total: `${numFormat(((callOffItem.additionalCharges*(100+vatPercent))/100))}`
      }
      returnedOrders.push(obj);
    }
  })
  return returnedOrders;
}
